"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SynchronousMap = void 0;
const read_write_lock_1 = require("./read-write.lock");
class SynchronousMap {
    map = new Map();
    mutexMap = new Map();
    mutexMapLock = new read_write_lock_1.ReadWriteLock();
    async get(key) {
        const lock = await this.getLockForKey(key);
        return lock?.acquireRead(() => this.map.get(key));
    }
    async set(key, value) {
        let lock = await this.getLockForKey(key);
        if (!lock) {
            await this.mutexMapLock.acquireWrite(() => {
                lock = this.mutexMap.get(key) ?? new read_write_lock_1.ReadWriteLock();
                this.mutexMap.set(key, lock);
            });
        }
        await lock.acquireWrite(() => {
            this.map.set(key, value);
        });
    }
    async withWriteForKey(key, func) {
        let lock = await this.getLockForKey(key);
        if (!lock) {
            await this.mutexMapLock.acquireWrite(() => {
                lock = this.mutexMap.get(key) ?? new read_write_lock_1.ReadWriteLock();
                this.mutexMap.set(key, lock);
            });
        }
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        const synchronousMapEntry = {
            get() {
                return self.map.get(key);
            },
            set(value) {
                self.map.set(key, value);
            },
        };
        await lock.acquireWrite(() => func(synchronousMapEntry));
    }
    async getLockForKey(key) {
        return (await this.mutexMapLock.acquireRead(() => this.mutexMap.get(key))) ?? null;
    }
}
exports.SynchronousMap = SynchronousMap;
